import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function JobOffersIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="77"
      viewBox="0 0 80 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2_1312)">
        <path
          d="M54.3807 59.4562H25.3777V71.0574H54.3807V59.4562Z"
          fill="#EAEEF9"
        />
        <path
          d="M75.6496 61.6314H4.35045C1.93353 61.6314 0 59.6979 0 57.281V4.35045C0 1.93353 1.93353 0 4.35045 0H75.6496C78.0665 0 80 1.93353 80 4.35045V57.281C80 59.6979 77.8248 61.6314 75.6496 61.6314Z"
          fill="#EAEEF9"
        />
        <path
          d="M66.4653 76.3746H13.5348C12.0847 76.3746 10.8762 75.1662 10.8762 73.716C10.8762 72.2659 12.0847 71.0574 13.5348 71.0574H66.4653C67.9155 71.0574 69.124 72.2659 69.124 73.716C69.124 75.1662 67.9155 76.3746 66.4653 76.3746Z"
          fill="#EAEEF9"
        />
        <path
          d="M72.2658 56.3142H7.73406C6.52561 56.3142 5.55884 55.3474 5.55884 54.139V7.73414C5.55884 6.52568 6.52561 5.55891 7.73406 5.55891H72.2658C73.4743 5.55891 74.441 6.52568 74.441 7.73414V54.139C74.441 55.3474 73.4743 56.3142 72.2658 56.3142Z"
          fill="white"
        />
        <path
          d="M71.5408 31.6616H8.45921C7.97582 31.6616 7.73413 31.4199 7.73413 30.9366C7.73413 30.4532 7.97582 30.2115 8.45921 30.2115H71.5408C72.0242 30.2115 72.2659 30.4532 72.2659 30.9366C72.2659 31.1783 72.0242 31.6616 71.5408 31.6616Z"
          fill="#00C4B3"
        />
        <path
          d="M39.8791 54.3807C39.3957 54.3807 39.1541 54.139 39.1541 53.6556V7.97584C39.1541 7.49245 39.3957 7.25076 39.8791 7.25076C40.3625 7.25076 40.6042 7.49245 40.6042 7.97584V53.6556C40.6042 54.139 40.3625 54.3807 39.8791 54.3807Z"
          fill="#00C4B3"
        />
        <path
          d="M22.4773 18.1269C17.6434 18.1269 13.7763 21.7523 13.0513 26.3444C13.0513 27.0695 13.5347 27.5529 14.018 27.5529H30.6948C31.4199 27.5529 31.9032 27.0695 31.6615 26.3444C31.1782 21.7523 27.3111 18.1269 22.4773 18.1269Z"
          fill="#00C4B3"
        />
        <path
          d="M29.7281 13.0514C29.7281 17.1601 26.5861 20.3021 22.4773 20.3021C18.3686 20.3021 15.2266 17.1601 15.2266 13.0514C15.2266 8.94259 18.3686 5.8006 22.4773 5.8006C26.5861 5.8006 29.7281 9.18428 29.7281 13.0514Z"
          fill="white"
        />
        <path
          d="M27.5529 13.0514C27.5529 15.9517 25.3777 18.1269 22.4774 18.1269C19.5771 18.1269 17.4019 15.9517 17.4019 13.0514C17.4019 10.1511 19.5771 7.97583 22.4774 7.97583C25.3777 7.97583 27.5529 10.1511 27.5529 13.0514Z"
          fill="#00C4B3"
        />
        <path
          d="M57.281 18.1269C52.4471 18.1269 48.5801 21.7523 47.855 26.3444C47.855 27.0695 48.3384 27.5529 48.8218 27.5529H65.4985C66.2236 27.5529 66.7069 27.0695 66.4653 26.3444C66.2236 21.7523 62.1148 18.1269 57.281 18.1269Z"
          fill="#00416B"
        />
        <path
          d="M64.5318 13.0514C64.5318 17.1601 61.3898 20.3021 57.281 20.3021C53.1723 20.3021 50.0303 17.1601 50.0303 13.0514C50.0303 8.94259 53.1723 5.8006 57.281 5.8006C61.3898 5.8006 64.5318 9.18428 64.5318 13.0514Z"
          fill="white"
        />
        <path
          d="M62.3564 13.0514C62.3564 15.9517 60.1812 18.1269 57.2809 18.1269C54.3805 18.1269 52.2053 15.9517 52.2053 13.0514C52.2053 10.1511 54.3805 7.97583 57.2809 7.97583C60.1812 7.97583 62.3564 10.1511 62.3564 13.0514Z"
          fill="#00416B"
        />
        <path
          d="M22.4773 43.9879C17.6434 43.9879 13.7763 47.6133 13.0513 52.2054C13.0513 52.9305 13.5347 53.4139 14.018 53.4139H30.6948C31.4199 53.4139 31.9032 52.9305 31.6615 52.2054C31.1782 47.6133 27.3111 43.9879 22.4773 43.9879Z"
          fill="#00416B"
        />
        <path
          d="M29.7281 38.9124C29.7281 43.0212 26.5861 46.1631 22.4773 46.1631C18.3686 46.1631 15.2266 43.0212 15.2266 38.9124C15.2266 34.8036 18.3686 31.6616 22.4773 31.6616C26.5861 31.6616 29.7281 34.8036 29.7281 38.9124Z"
          fill="white"
        />
        <path
          d="M27.5529 38.9124C27.5529 41.8127 25.3777 43.9879 22.4774 43.9879C19.5771 43.9879 17.4019 41.8127 17.4019 38.9124C17.4019 36.0121 19.5771 33.8369 22.4774 33.8369C25.3777 33.8369 27.5529 36.0121 27.5529 38.9124Z"
          fill="#00416B"
        />
        <path
          d="M57.281 43.9879C52.4471 43.9879 48.5801 47.6133 47.855 52.2054C47.855 52.9305 48.3384 53.4139 48.8218 53.4139H65.4985C66.2236 53.4139 66.7069 52.9305 66.4653 52.2054C66.2236 47.6133 62.1148 43.9879 57.281 43.9879Z"
          fill="#00C4B3"
        />
        <path
          d="M64.5318 38.9124C64.5318 43.0212 61.3898 46.1631 57.281 46.1631C53.1723 46.1631 50.0303 43.0212 50.0303 38.9124C50.0303 34.8036 53.1723 31.6616 57.281 31.6616C61.3898 31.6616 64.5318 34.8036 64.5318 38.9124Z"
          fill="white"
        />
        <path
          d="M62.3564 38.9124C62.3564 41.8127 60.1812 43.9879 57.2809 43.9879C54.3805 43.9879 52.2053 41.8127 52.2053 38.9124C52.2053 36.0121 54.3805 33.8369 57.2809 33.8369C60.1812 33.8369 62.3564 36.0121 62.3564 38.9124Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_1312">
          <rect width="80" height="76.3746" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
